import { Lightning } from '@lightningjs/sdk';
import { HoverableComponent } from 'components/common/HoverableComponent';
import { translate } from 'support/translate';
import QrCodeSection from '../common/QrCodeSection';
import SignUpSection from '../sign-up/SignUpSection';
import SignInSection from '../sign-in/SignInSection';
import EmailInputSection from '../email-input/EmailInputSection';
import TextLabel from 'components/common/TextLabel';

export interface AbstractLoginSplitContentTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Content: {
    LeftSection:
      | typeof SignUpSection
      | typeof SignInSection
      | typeof EmailInputSection;
    Separator: {
      LineTop: object;
      Text: typeof TextLabel;
      LineBottom: object;
    };
    RightSection: typeof QrCodeSection;
  };
}

const CONTENT_WIDTH = 1696;
const CONTENT_HEIGHT = 522;
const SECTION_WIDTH = 684;
const SECTION_HEIGHT = 522;
const SEPARATOR_WIDTH = 32;
const SEPARATOR_MARGIN = 148;
const SEPARATOR_LINE_HEIGHT = 187;
const SEPARATOR_LINE_WIDTH = 2;

export default abstract class AbstractLoginSplitContent extends HoverableComponent<AbstractLoginSplitContentTemplateSpec> {
  private _Content = this.getByRef('Content')!;
  protected _LeftSection = this._Content.getByRef('LeftSection');

  static override _template(): Lightning.Component.Template<AbstractLoginSplitContentTemplateSpec> {
    return {
      Content: {
        x: 32,
        y: 32,
        w: CONTENT_WIDTH,
        h: CONTENT_HEIGHT,
        LeftSection: {
          // Implemented by derived component
          type: SignUpSection || SignInSection || EmailInputSection,
          w: SECTION_WIDTH,
          h: SECTION_HEIGHT,
        },
        Separator: {
          w: SEPARATOR_WIDTH,
          h: SECTION_HEIGHT,
          x: SECTION_WIDTH + SEPARATOR_MARGIN,
          flex: {
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          },
          LineTop: {
            w: SEPARATOR_LINE_WIDTH,
            h: SEPARATOR_LINE_HEIGHT,
            rect: true,
          },
          Text: {
            type: TextLabel,
            w: 100,
            flexItem: {
              marginTop: 36,
              marginBottom: 36,
            },
            text: {
              text: translate('account.modal.separatorText'),
              textAlign: 'center',
              fontSize: 18,
            },
          },
          LineBottom: {
            w: SEPARATOR_LINE_WIDTH,
            h: SEPARATOR_LINE_HEIGHT,
            rect: true,
          },
        },
        RightSection: {
          type: QrCodeSection,
          w: SECTION_WIDTH,
          h: SECTION_HEIGHT,
          x: SECTION_WIDTH + SEPARATOR_MARGIN * 2 + SEPARATOR_WIDTH,
        },
      },
    };
  }

  override _getFocused() {
    return this._LeftSection;
  }
}
